// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"6ecbddaa","498":"d05e2af2","703":"92f9a739"}[chunkId] + ".chunk.js";
};